<template>
	<div style="min-height: 600px;">
		<insBox :title="'大型仪器简介'" :nextTitle="'Introduction to large instruments'">
			<template slot="box">
				<img style="width: 50%; height: 300px;" src="../../assets/images/yqjjd.png">
			</template>
		</insBox>
		<div style="width: 1200px;margin: 0 auto;margin-top: 60px;">
			<div style="position: relative; align-items: center; width: 1200px;height: 70px;border-bottom: 1px solid #EBEBEB;display: flex;justify-content: space-between;">
				<div style="font-size: 26px;color: #151515;position: relative;">
					仪器简介
					<img src="../../assets/images/qiud.png" style="position: absolute;left: -5px;">
				</div>
				<div v-if="(InstrumentDetailedData.state=='空闲'||InstrumentDetailedData.state=='运行中')&&InstrumentDetailedData.reservable" @click="goToDetail" class="hovers" style="cursor: pointer; display: flex;justify-content: center;align-items: center; color: #FFFFFF;font-size: 16px; left: 400px;top: 90px; width: 112px;height: 40px;border-radius: 4px;background: #165FDC;position: absolute;">
					立即预约
				</div>
				<div style="color: #999999;font-size: 12px;font-family: DIN-Regular;text-transform: uppercase;">
					<!-- <div>Instrument</div>
					<div>introduction</div> -->
				</div>
			</div>
			<div style="width: 100%;display: flex;justify-content: space-between;margin-top: 32px;">
				<div style="width: 500px;font-size: 16px;">
					<div style="display: flex;">
						<div style="color: #666666;">
							仪器名称：
						</div>
						<div style="margin-left: 16px;color: #165FDC;">
							{{InstrumentDetailedData.instrumentName}}
						</div>
					</div>
					<div style="display: flex;margin-top: 12px;">
						<div style="color: #666666;">
							所在科室：
						</div>
						<div style="margin-left: 16px;color: #333333;">
							{{InstrumentDetailedData.labName}}
						</div>
					</div>
					<div style="display: flex;margin-top: 12px;">
						<div style="color: #666666;">
							放置位置：
						</div>
						<div style="margin-left: 16px;color: #333333;">
							{{InstrumentDetailedData.locationDetail}}
						</div>
					</div>
					<div style="display: flex;margin-top: 12px;">
						<div style="color: #666666;">
							品牌厂家：
						</div>
						<div style="margin-left: 16px;color: #333333;">
							{{InstrumentDetailedData.company}}
						</div>
					</div>
					<div style="display: flex;margin-top: 12px;">
						<div style="color: #666666;">
							型号规格：
						</div>
						<div style="margin-left: 16px;color: #333333;">
							{{InstrumentDetailedData.model}}
						</div>
					</div>
					<div v-if="InstrumentDetailedData.agent" style="display: flex;margin-top: 12px;">
						<div style="color: #666666;">
							仪器负责人：
						</div>
						<div style="margin-left: 16px;color: #333333;">
							{{InstrumentDetailedData.contactName}}
						</div>
					</div>
					<div  style="display: flex;margin-top: 12px;">
						<div style="color: #666666;">
							管理员：
						</div>
						<div style="margin-left: 28px;color: #333333;">
							{{InstrumentDetailedData.realName}}
						</div>
					</div>
					<div  style="display: flex;margin-top: 12px;">
						<div style="color: #666666;">
							联系电话：
						</div>
						<div style="margin-left: 8px;color: #333333;">
							{{InstrumentDetailedData.contactPhone}}
						</div>
					</div>
					
				</div>
				<img :src="InstrumentDetailedData.picture" style="width: 464px;height: 368px;">
			</div>
		</div>
		<div style="width: 1200px;margin: 0 auto;margin-top: 60px;">
			<div style="position: relative; align-items: center; width: 1200px;height: 70px;border-bottom: 1px solid #EBEBEB;display: flex;justify-content: space-between;">
				<div style="font-size: 26px;color: #151515;position: relative;">
					仪器介绍
					<img src="../../assets/images/qiud.png" style="position: absolute;left: -5px;">
				</div>
				
				<div style="color: #999999;font-size: 12px;font-family: DIN-Regular;text-transform: uppercase;">
					<!-- <div>Instrument</div>
					<div>introduction</div> -->
				</div>
			</div>
			<div style="width: 100%;display: flex;justify-content: space-between;margin-top: 32px;">
				<div style="width: 500px;font-size: 16px;min-height: 160px;" v-html="InstrumentDetailedData.explain">
					
					
				</div>
				
			</div>
		</div>
		<div style="width: 1200px;margin: 0 auto;margin-top: 60px;">
			<div style="position: relative; align-items: center; width: 1200px;height: 70px;border-bottom: 1px solid #EBEBEB;display: flex;justify-content: space-between;">
				<div style="font-size: 26px;color: #151515;position: relative;">
					技术参数
					<img src="../../assets/images/qiud.png" style="position: absolute;left: -5px;">
				</div>
				
				<div style="color: #999999;font-size: 12px;font-family: DIN-Regular;text-transform: uppercase;">
					<!-- <div>technical</div>
					<div>parameter</div> -->
				</div>
			</div>
			<div style="width: 100%;display: flex;justify-content: space-between;margin-top: 32px;">
				<div style="width: 500px;font-size: 16px;min-height: 160px;" v-html="InstrumentDetailedData.technicalParameter">
					
					
				</div>
				
			</div>
		</div>
		<div style="width: 1200px;margin: 0 auto;margin-top: 60px;margin-bottom: 60px;">
			<div style="position: relative; align-items: center; width: 1200px;height: 70px;border-bottom: 1px solid #EBEBEB;display: flex;justify-content: space-between;">
				<div style="font-size: 26px;color: #151515;position: relative;">
					应用范围
					<img src="../../assets/images/qiud.png" style="position: absolute;left: -5px;">
				</div>
				
				<div style="color: #999999;font-size: 12px;font-family: DIN-Regular;text-transform: uppercase;">
					<!-- <div>Scope of</div>
					<div>application</div> -->
				</div>
			</div>
			<div style="width: 100%;display: flex;justify-content: space-between;margin-top: 32px;">
				<div style="width: 500px;font-size: 16px;min-height: 160px;" v-html="InstrumentDetailedData.scopeOfApplication">
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		SelInstrument,
		SelInstrumentDetailed
	} from '@/api/index.js'
	import insBox from '../../components/insBox.vue'
	export default {
		components: {
			insBox
		},
		data() {
			return {
				source: {},
				datas:[],
				InstrumentDetailedData:[]
			}
		},
		created() {
			// this.getSelInstrument()
			this.getSelInstrumentDetailed({
				InstrumentId:this.$route.query.id,
				weekIndex:0
			})
		},
		methods: {
			async getSelInstrument() {
				let data = {
					page: 1,
					row: 1000,
					IsAccessControl: 2
				}
				const res = await SelInstrument(data)
					 res.data.data.map((n)=>{
						 if(n.instrumentId==this.$route.query.id){
							 this.source = n
						 }
					 })
					
			
			},
			async getSelInstrumentDetailed(data,statess){
				const res = await SelInstrumentDetailed(data)
				
				this.InstrumentDetailedData = res.data.data
				
			},
			goToDetail(){
				this.$router.push({path:'/instrumentDetail',query: {ids: this.$route.query.id}})
			}
		}
	}
</script>

<style>
	.hovers:hover{
		opacity: 0.8;
	}
</style>
